// @flow

import { jsonResponse } from "fetch-utilities";
import type { Fetch }   from "fetch-utilities";

export const LOADED    = "store/procurement/LOADED";
export const LOADING   = "store/procurement/LOADING";
export const PENDING   = "store/procurement/PENDING";
export const SET_LIMIT = "store/procurement/SET_LIMIT";

const initialState = {
  loaded : false,
  state  : PENDING,
  data   : {
    category : {},
    products : [],
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        state: LOADING,
      };

    case LOADED:
      return {
        state  : LOADED,
        data   : action.error ? state.data : action.payload,
        loaded : !action.error
      };

    case SET_LIMIT:
      return {
        ...state,
        data: {
          ...state.data,
          products: state.data.products.map(p => action.skus.includes(p.sku) ? { ...p, qtyLimit: action.limit } : p)
        }
      };

    default:
      return state;
  }
}

export const load = id => (dispatch: Function, _getState: Function, client: Fetch) => {
  if (!id) {
    return;
  }

  dispatch({
    type: LOADING
  });

  dispatch({
    type    : LOADED,
    payload : client(`/categories/${id}`).then(jsonResponse)
  });
};

export const setQtyLimit = (limit, skus) => ({
  type: SET_LIMIT,
  limit,
  skus
});
